// GTMにABテスト用のDimensionを送信する
document.addEventListener('turbolinks:load', () => {
  const separatedTestContainers = document.querySelectorAll('[data-separated-test-id]');
  if (!separatedTestContainers) return;

  for (let i = 0; i < separatedTestContainers.length; i += 1) {
    const separatedTestContainer = separatedTestContainers[i];

    const separatedTestId = separatedTestContainer.getAttribute('data-separated-test-id');
    const separatedTestName = separatedTestContainer.getAttribute('data-separated-test-name');

    window.dataLayer.push({ 'SeparatedTestID': separatedTestId, 'SeparatedTestName': separatedTestName });
  }
});
